import React from 'react';
import { useAuthControllerChangePasswordMutation } from '@/store/services/MidleNestApi.service';
import { ReformSetError } from '@kodkafa/reform/dist/Form';
import { errorHandler } from '@/utils/error.handler';
import { ErrorArea, Form, PasswordInput, Submit } from '@kodkafa/reform';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { systemActions } from '@/store/features';
import { useAuth, useProfile } from '@/hooks';

export function ChangePasswordView() {
  const { t } = useTranslation();
  const [mutation] = useAuthControllerChangePasswordMutation();
  const dispatch = useDispatch();
  const { roles } = useAuth();
  const { profile } = useProfile();

  const handleSubmit = async (data: any, setError: ReformSetError) => {
    await mutation(data)
      .unwrap()
      .then(() => {
        // TODO  if user wants drop all active session so it return new session too
        // dispatch(changeName(payload));
        // dispatch(updated(payload));
        // console.log({ payload });
        gtag('event', 'change-password', { user: profile.id });

        dispatch(
          systemActions.pushMessage({ message: t('Your password has been changed successfully.') }),
        );
      })
      .catch((error) => errorHandler(error, setError));
  };
  return (
    <div className='flex flex-col h-full items-stretch dark:text-white'>
      <div className='grow-0 text-xl font-bold'>
        <h3 className=''>{t('Change Password')}</h3>
      </div>
      <div className='grow pt-4 pb-10 px-1 -mx-1 overflow-y-auto'>
        <Form onSubmit={handleSubmit} className='flex !gap-4 md:w-80'>
          {!roles.includes('passwordless') && (
            <div>
              <PasswordInput
                name='password'
                label={t('Current Password')}
                placeholder={t('type your current password ...')}
                className='dark:!bg-transparent dark:!border-[#FFDA68] dark:!text-white dark:placeholder:text-white/50 dark:ring-transparent'
                show={<i className='icon-eye px-1.5 cursor-pointer' />}
                hide={<i className='icon-eye-off px-1.5 cursor-pointer' />}
              />
            </div>
          )}
          <div>
            <PasswordInput
              name='newPassword'
              label={t('New Password')}
              placeholder={t('create a new password ...')}
              className='dark:!bg-transparent dark:!border-[#FFDA68] dark:!text-white dark:placeholder:text-white/50 dark:ring-transparent'
              show={<i className='icon-eye px-1.5 cursor-pointer' />}
              hide={<i className='icon-eye-off px-1.5 cursor-pointer' />}
            />
          </div>
          <ErrorArea />
          <div>
            <Submit>{t('Change my password')}</Submit>
          </div>
        </Form>
      </div>
    </div>
  );
}
